import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.jsx';
import { applyTheme, storedTheme } from './ui/theme.js';
import './index.css';

/**
 * BEFORE `createRoot`, deliberately.
 *
 * The CSP on the admin host is `script-src 'self'` (deploy/Caddyfile), so there
 * is no inline script in `index.html` to set this earlier — this is the earliest
 * point available. Running it above the render means React's first paint already
 * has the right palette, rather than painting dark and correcting itself.
 */
applyTheme(storedTheme());

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
